import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApiMutation';
import { operationsClient } from '@/lib/api/client';
import { taxZoneEndpoints } from '@/lib/api/endpoints';
import { taxZoneKeys, taxGroupKeys } from '@/lib/queryKeys';

export function useDeleteTaxZone() {
  const qc = useQueryClient();

  return useApiMutation<void, { id: string }>({
    mutationFn: ({ id }) =>
      operationsClient.delete(taxZoneEndpoints.byId(id)).then(() => undefined),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: taxZoneKeys.all() });
      void qc.invalidateQueries({ queryKey: taxGroupKeys.all() });
    },
  });
}
